<div class="users-list-page">
  <div class="page-header">
    <div class="header-content">
      <h1>Liste des utilisateurs</h1>
      <p class="subtitle">Gérez tous les utilisateurs de la plateforme</p>
    </div>
  </div>

  <!-- Filters - Always visible -->
  <div class="list-filters">
    <div class="filter-item">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <path d="M11 5h10M11 9h7M11 13h4M3 17l3 3 3-3M6 18V4" />
      </svg>
      <select [ngModel]="sortOption()" (ngModelChange)="onSortChange($event)">
        <option value="name-asc">Alphabétique</option>
        <option value="name-desc">Alphabétique inversé</option>
        <option value="created-at-desc">Inscription récente</option>
        <option value="created-at-asc">Inscription ancienne</option>
        <option value="last-login-desc">Connexion récente</option>
        <option value="last-login-asc">Connexion ancienne</option>
      </select>
    </div>
    <div class="search-box">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <circle cx="11" cy="11" r="8" />
        <path d="M21 21l-4.35-4.35" />
      </svg>
      <input
        type="text"
        placeholder="Rechercher par nom, pseudo, prénom ou email..."
        [value]="searchQuery()"
        (input)="onSearchChange($any($event.target).value)"
      />
      @if (searchQuery()) {
      <button type="button" class="clear-search" (click)="clearSearch()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
      }
    </div>
  </div>

  @if (loading()) {
  <div class="loading">
    <div class="spinner"></div>
    <p>Chargement des utilisateurs...</p>
  </div>
  } @else if (error()) {
  <div class="error-message">
    <p>{{ error() }}</p>
    <button type="button" (click)="loadUsers()">Réessayer</button>
  </div>
  } @else if (users().length === 0) {
  <div class="empty-state">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
    >
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
    @if (searchQuery()) {
    <h3>Aucun résultat</h3>
    <p>Aucun utilisateur ne correspond à "{{ searchQuery() }}"</p>
    } @else {
    <h3>Aucun utilisateur</h3>
    <p>Il n'y a pas encore d'utilisateurs inscrits</p>
    }
  </div>
  } @else {
  <!-- Desktop Table View -->
  <div class="users-table-wrapper">
    <table class="users-table">
      <thead>
        <tr>
          <th>Photo</th>
          <th>Nom d'utilisateur</th>
          <th>Prénom</th>
          <th>Nom</th>
          <th>Email</th>
          <th>Ville</th>
          <th>Âge</th>
          <th>Inscription</th>
          <th>Dernière connexion</th>
          <th>Statut</th>
          <th>Rôle</th>
          <th>Premium</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (user of users(); track user.id) {
        <tr>
          <td class="cell-image">
            @if (user.imgUrl) {
            <img
              [src]="user.imgUrl | versionedImageUrl : user.profileImageUpdatedAt"
              [alt]="user.userName"
              loading="lazy"
            />
            } @else {
            <div class="avatar-placeholder">
              {{
                user.userName
                  ? user.userName.charAt(0).toUpperCase()
                  : user.firstname
                  ? user.firstname.charAt(0).toUpperCase()
                  : '?'
              }}
            </div>
            }
          </td>
          <td class="cell-name">{{ user.userName || '-' }}</td>
          <td class="cell-firstname">{{ user.firstname || '-' }}</td>
          <td class="cell-lastname">{{ user.lastname || '-' }}</td>
          <td class="cell-email">{{ user.email }}</td>
          <td class="cell-city">{{ user.city || '-' }}</td>
          <td class="cell-age">{{ user.age || '-' }}</td>
          <td class="cell-created-at">{{ formatCreatedAt(user.createdAt) }}</td>
          <td class="cell-last-login">{{ formatLastLogin(user.lastLoginAt) }}</td>
          <td class="cell-status">
            @if (!isUserActive(user)) {
            <span class="badge badge-danger">Désactivé</span>
            } @else if (user.profileStatus === 'ACTIVE') {
            <span class="badge badge-success">Actif</span>
            } @else {
            <span class="badge badge-warning">Incomplet</span>
            }
          </td>
          <td class="cell-role">
            <div class="role-select-wrapper">
              <select
                class="role-select"
                [ngModel]="getSelectedRole(user)"
                (ngModelChange)="onRoleSelectionChange(user, $event)"
                [disabled]="isUpdatingRole(user.id)"
              >
                @for (option of roleOptions; track option.value) {
                <option [ngValue]="option.value">{{ option.label }}</option>
                }
              </select>
              <button
                type="button"
                class="role-save-btn"
                [disabled]="!hasPendingRole(user) || isUpdatingRole(user.id)"
                (click)="saveUserRole(user)"
              >
                Valider
              </button>
              @if (isUpdatingRole(user.id)) {
              <span class="role-saving">...</span>
              }
            </div>
          </td>
          <td class="cell-premium">
            <button
              type="button"
              class="badge-premium"
              [class.premium]="user.isPremium"
              (click)="togglePremium(user)"
              [title]="user.isPremium ? 'Retirer le statut Premium' : 'Passer en Premium'"
            >
              {{ user.isPremium ? 'P' : 'F' }}
            </button>
          </td>
          <td class="cell-actions">
            <button
              type="button"
              class="btn-action view"
              (click)="viewProfile(user)"
              title="Voir le profil"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
            </button>
            <button
              type="button"
              class="btn-action"
              [class.pause]="isUserActive(user)"
              [class.play]="!isUserActive(user)"
              (click)="confirmToggleActive(user)"
              [title]="isUserActive(user) ? 'Désactiver le compte' : 'Réactiver le compte'"
            >
              @if (isUserActive(user)) {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <rect x="6" y="5" width="4" height="14" rx="1" />
                <rect x="14" y="5" width="4" height="14" rx="1" />
              </svg>
              } @else {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M8 5v14l11-7z" />
              </svg>
              }
            </button>
            <button
              type="button"
              class="btn-action delete"
              (click)="confirmDelete(user)"
              title="Supprimer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <polyline points="3 6 5 6 21 6" />
                <path
                  d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
                />
              </svg>
            </button>
          </td>
        </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- Pagination Controls -->
  <div class="pagination-wrapper">
    <div class="pagination-left">
      <span class="pagination-info">
        {{ (currentPage() - 1) * itemsPerPage() + 1 }}-{{
          currentPage() * itemsPerPage() > totalElements()
            ? totalElements()
            : currentPage() * itemsPerPage()
        }}
        sur {{ totalElements() }}
      </span>
    </div>
    <div class="pagination-center">
      <button
        type="button"
        class="pagination-btn"
        [disabled]="currentPage() === 1"
        (click)="previousPage()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>
      <div class="pagination-pages">
        @for (page of [].constructor(totalPages()); track $index) {
        <button
          type="button"
          class="page-number"
          [class.active]="currentPage() === $index + 1"
          (click)="goToPage($index + 1)"
        >
          {{ $index + 1 }}
        </button>
        }
      </div>
      <button
        type="button"
        class="pagination-btn"
        [disabled]="currentPage() === totalPages()"
        (click)="nextPage()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>
    </div>
    <div class="pagination-right">
      <select [ngModel]="itemsPerPage()" (ngModelChange)="onItemsPerPageChange($event)">
        <option [ngValue]="10">10 / page</option>
        <option [ngValue]="25">25 / page</option>
        <option [ngValue]="50">50 / page</option>
        <option [ngValue]="100">100 / page</option>
      </select>
    </div>
  </div>

  <!-- Mobile Cards View -->
  <div class="users-mobile-cards">
    @for (user of users(); track user.id) {
    <div class="user-card" [class.expanded]="isUserExpanded(user.id)">
      <button type="button" class="user-card-header" (click)="toggleUserExpand(user.id)">
        @if (user.imgUrl) {
        <img
          [src]="user.imgUrl | versionedImageUrl : user.profileImageUpdatedAt"
          [alt]="user.userName"
          class="user-avatar"
          loading="lazy"
        />
        } @else {
        <div class="avatar-placeholder">
          {{
            user.userName
              ? user.userName.charAt(0).toUpperCase()
              : user.firstname
              ? user.firstname.charAt(0).toUpperCase()
              : '?'
          }}
        </div>
        }
        <div class="user-main-info">
          <span class="user-name">
            {{ user.userName || user.firstname || 'Utilisateur' }}
            @if (user.isPremium) {
            <span class="premium-indicator">P</span>
            }
          </span>
          <span class="user-email">{{ user.email }}</span>
        </div>
        <div class="expand-indicator">
          @if (!isUserActive(user)) {
          <span class="status-dot inactive"></span>
          } @else if (user.profileStatus === 'ACTIVE') {
          <span class="status-dot active"></span>
          } @else {
          <span class="status-dot incomplete"></span>
          }
          <svg
            class="chevron-icon"
            [class.rotated]="isUserExpanded(user.id)"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
      </button>
      @if (isUserExpanded(user.id)) {
      <div class="user-card-body">
        <div class="user-info-item">
          <span class="info-label">Prénom</span>
          <span class="info-value">{{ user.firstname || '-' }}</span>
        </div>
        <div class="user-info-item">
          <span class="info-label">Nom</span>
          <span class="info-value">{{ user.lastname || '-' }}</span>
        </div>
        <div class="user-info-item">
          <span class="info-label">Ville</span>
          <span class="info-value">{{ user.city || '-' }}</span>
        </div>
        <div class="user-info-item">
          <span class="info-label">Âge</span>
          <span class="info-value">{{ user.age ? user.age + ' ans' : '-' }}</span>
        </div>
        <div class="user-info-item">
          <span class="info-label">Compte</span>
          <span class="info-value">{{ isUserActive(user) ? 'Actif' : 'Désactivé' }}</span>
        </div>
        <div class="user-info-item">
          <span class="info-label">Dernière connexion</span>
          <span class="info-value">{{ formatLastLogin(user.lastLoginAt) }}</span>
        </div>
        <div class="user-info-item">
          <span class="info-label">Inscription</span>
          <span class="info-value">{{ formatCreatedAt(user.createdAt) }}</span>
        </div>
        <div class="user-info-item role-item">
          <span class="info-label">Rôle</span>
          <select
            class="role-select"
            [ngModel]="getSelectedRole(user)"
            (ngModelChange)="onRoleSelectionChange(user, $event)"
            [disabled]="isUpdatingRole(user.id)"
          >
            @for (option of roleOptions; track option.value) {
            <option [ngValue]="option.value">{{ option.label }}</option>
            }
          </select>
          <button
            type="button"
            class="role-save-btn"
            [disabled]="!hasPendingRole(user) || isUpdatingRole(user.id)"
            (click)="saveUserRole(user)"
          >
            Valider
          </button>
        </div>
      </div>
      <div class="user-card-actions">
        <button type="button" class="btn-action-mobile view" (click)="viewProfile(user)">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
          Profil
        </button>
        <button
          type="button"
          class="btn-action-mobile"
          [class.pause]="isUserActive(user)"
          [class.play]="!isUserActive(user)"
          (click)="confirmToggleActive(user)"
        >
          @if (isUserActive(user)) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <rect x="6" y="5" width="4" height="14" rx="1" />
            <rect x="14" y="5" width="4" height="14" rx="1" />
          </svg>
          <span>Pause</span>
          } @else {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M8 5v14l11-7z" />
          </svg>
          <span>Réactiver</span>
          }
        </button>
        <button
          type="button"
          class="btn-action-mobile premium"
          [class.is-premium]="user.isPremium"
          (click)="togglePremium(user)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <polygon
              points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
            />
          </svg>
          {{ user.isPremium ? 'Retirer P' : 'Passer P' }}
        </button>
        <button type="button" class="btn-action-mobile delete" (click)="confirmDelete(user)">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <polyline points="3 6 5 6 21 6" />
            <path
              d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
            />
          </svg>
          Supprimer
        </button>
      </div>
      }
    </div>
    }
  </div>

  <!-- Modal pour afficher le profil -->
  @if (showProfileModal() && selectedUser()) {
  <div
    class="modal-overlay"
    role="dialog"
    aria-modal="true"
    (click)="closeProfileModal()"
    (keyup.escape)="closeProfileModal()"
  >
    <div
      class="modal-content profile-modal"
      role="document"
      (click)="$event.stopPropagation()"
      (keyup.escape)="closeProfileModal()"
    >
      <div class="modal-header">
        <h3>Profil utilisateur</h3>
        <button type="button" class="close-btn" (click)="closeProfileModal()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="profile-header">
          @if (selectedUser()!.imgUrl) {
          <img
            [src]="
              selectedUser()!.imgUrl | versionedImageUrl : selectedUser()!.profileImageUpdatedAt
            "
            [alt]="selectedUser()!.userName"
            class="profile-avatar"
          />
          } @else {
          <div class="avatar-placeholder large">
            {{ selectedUser()!.userName ? selectedUser()!.userName!.charAt(0).toUpperCase() : '?' }}
          </div>
          }
          <h4>{{ selectedUser()!.userName }}</h4>
        </div>
        <div class="profile-details">
          <div class="detail-row">
            <span class="label">Email</span>
            <span class="value">{{ selectedUser()!.email }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Ville</span>
            <span class="value">{{ selectedUser()!.city || 'Non renseignée' }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Âge</span>
            <span class="value">{{
              selectedUser()!.age ? selectedUser()!.age + ' ans' : 'Non renseigné'
            }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Prénom</span>
            <span class="value">{{ selectedUser()!.firstname || 'Non renseigné' }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Nom</span>
            <span class="value">{{ selectedUser()!.lastname || 'Non renseigné' }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Description</span>
            <span class="value">{{ selectedUser()!.description || 'Non renseignée' }}</span>
          </div>
          @if (selectedUser()!.isPremium) {
          <div class="premium-badge">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <polygon
                points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
              />
            </svg>
            Premium
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  }

  <!-- Modal de confirmation de désactivation/réactivation -->
  @if (showActiveModal() && userToToggleActive()) {
  <div
    class="modal-overlay"
    role="dialog"
    aria-modal="true"
    (click)="closeActiveModal()"
    (keyup.escape)="closeActiveModal()"
  >
    <div
      class="modal-content active-modal"
      role="document"
      (click)="$event.stopPropagation()"
      (keyup.escape)="closeActiveModal()"
    >
      <div class="modal-header warning">
        <h3>
          {{ isUserActive(userToToggleActive()!) ? 'Désactiver ce compte' : 'Réactiver ce compte' }}
        </h3>
        <button type="button" class="close-btn" (click)="closeActiveModal()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="warning-icon account-state">
          @if (isUserActive(userToToggleActive()!)) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <rect x="6" y="5" width="4" height="14" rx="1" />
            <rect x="14" y="5" width="4" height="14" rx="1" />
          </svg>
          } @else {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M8 5v14l11-7z" />
          </svg>
          }
        </div>
        <p class="warning-text">
          Êtes-vous sûr de vouloir
          {{ isUserActive(userToToggleActive()!) ? 'désactiver' : 'réactiver' }}
          le compte de <strong>{{ userToToggleActive()!.userName }}</strong> ?
        </p>
        <p class="warning-subtext">
          {{
            isUserActive(userToToggleActive()!)
              ? "L'utilisateur ne pourra plus se connecter et sera retiré de sa session active."
              : "L'utilisateur pourra de nouveau se connecter."
          }}
        </p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-cancel" (click)="closeActiveModal()">Annuler</button>
        <button
          type="button"
          class="btn-toggle-active"
          [class.reactivate]="!isUserActive(userToToggleActive()!)"
          (click)="toggleActiveUser()"
          [disabled]="togglingActive()"
        >
          @if (togglingActive()) {
          <span class="spinner-small"></span>
          Mise à jour... } @else {
          {{ isUserActive(userToToggleActive()!) ? 'Désactiver' : 'Réactiver' }}
          }
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Modal de confirmation de suppression -->
  @if (showDeleteModal() && userToDelete()) {
  <div
    class="modal-overlay"
    role="dialog"
    aria-modal="true"
    (click)="closeDeleteModal()"
    (keyup.escape)="closeDeleteModal()"
  >
    <div
      class="modal-content delete-modal"
      role="document"
      (click)="$event.stopPropagation()"
      (keyup.escape)="closeDeleteModal()"
    >
      <div class="modal-header danger">
        <h3>Confirmer la suppression</h3>
        <button type="button" class="close-btn" (click)="closeDeleteModal()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
      </div>
      <div class="modal-body">
        <div class="warning-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
            />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
        <p class="warning-text">
          Êtes-vous sûr de vouloir supprimer l'utilisateur
          <strong>{{ userToDelete()!.userName }}</strong> ?
        </p>
        <p class="warning-subtext">Cette action est irréversible.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-cancel" (click)="closeDeleteModal()">Annuler</button>
        <button type="button" class="btn-delete" (click)="deleteUser()" [disabled]="deleting()">
          @if (deleting()) {
          <span class="spinner-small"></span>
          Suppression... } @else { Supprimer }
        </button>
      </div>
    </div>
  </div>
  } }
</div>
